module.exports = __webpack_public_path__ + "img/Most-Critical.e7d71991.png";